import React, { useEffect, useRef, useState } from "react";
import * as pdfjsLib from "pdfjs-dist";
import { Trans, useTranslation } from "react-i18next";
import "./documentHandler.sass";
import { Box } from "@mui/material";
import { apiUser } from "../basedata/apiCall";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import ModalInfo from "../components/Modal/ModalInfo";
import CloseIcon from "@mui/icons-material/Close";
import { FiTrash2, FiUploadCloud } from "react-icons/fi";

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.js", import.meta.url).toString();

const WaFiTrash2 = FiTrash2 as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaFiUploadCloud = FiUploadCloud as React.ComponentType<React.SVGProps<SVGSVGElement>>;

const DocumentHandler = () => {
  const { t } = useTranslation();

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [selectedFileName, setSelectedFileName] = useState<string | null>(null);
  const [uploadComplete, setUploadComplete] = useState(false);
  const [previewUrl] = useState<string | undefined>();
  const [error, setError] = useState<string | null>(null);
  const [isSending, setIsSending] = useState(false);

  const progressRef = useRef<NodeJS.Timeout | null>(null);

  const documentHandlerUrl = () => {
    window.location.href = "/instructions-document";
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    input.value = "";

    if (!file) return;

    if (file.type !== "application/pdf") {
      setError("Please upload a valid PDF file.");
      return;
    }
    setError(null);

    setSelectedFile(file);
    setSelectedFileName(file.name);
    setIsLoading(true);
    setUploadComplete(false);
    setLoadingProgress(0);

    if (progressRef.current) clearInterval(progressRef.current);
    progressRef.current = setInterval(() => {
      setLoadingProgress((p) => (p < 95 ? p + 5 : p));
    }, 150);

    try {
      const [croppedBase64, fullPdfBase64] = await fileToBase64(file);

      const _upload_response = await apiUser.post('/biometry/saffe/facematch/document', {
        token: sessionStorage.getItem('token') || 'na',
        images: [croppedBase64, fullPdfBase64],
        flow: "onboarding",
      },{
          maxBodyLength: Infinity,
          maxContentLength: Infinity,
        });


      if (_upload_response?.data?.message !== 'success' && _upload_response?.data?.message !== 'done') {
        if (progressRef.current) clearInterval(progressRef.current);
        setIsLoading(false);
        setUploadComplete(false);
       return  setIsSuccessModalOpen(true);
      }

      return window.location.href = "/thinking";


    } catch (err: any) {
      if (progressRef.current) clearInterval(progressRef.current);
      setIsLoading(false);
      setUploadComplete(false);
      setIsSuccessModalOpen(true);
    }
  };

  const handleSend = async () => {
    if (!selectedFile) return;
    setIsSending(true);

    console.log('oi, fui né?')
    return false
    try {
      const _validate_doc = await apiUser.post(`/biometry/onboarding/user-jorney`, {
        flowId: sessionStorage.getItem("token") || "na",
      });

      if (_validate_doc?.data?.status === "success" && _validate_doc?.data?.message === "done") {
        window.location.href = "/thinking";
        return;
      }
      setIsSuccessModalOpen(true);
    } catch (err: any) {
      console.error("validate error", {
        status: err?.response?.status,
        data: err?.response?.data,
        message: err?.message,
      });
      setIsSuccessModalOpen(true);
    } finally {
      setIsSending(false);
    }
  };

  const fileToBase64 = (file: File): Promise<[string, string]> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = async () => {
        try {
          const typedArray = new Uint8Array(reader.result as ArrayBuffer);
          const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise;
          const page = await pdf.getPage(1);
          const viewport = page.getViewport({ scale: 2 });
          const canvas = document.createElement("canvas");
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          await page.render({ canvasContext: canvas.getContext("2d")!, viewport }).promise;
          const fullPdfBase64 = canvas.toDataURL("image/jpeg", 0.92);
          const cropWidth = Math.floor(viewport.width * 0.5);
          const cropHeight = Math.floor(viewport.height * 0.3);
          const cropped = document.createElement("canvas");
          cropped.width = cropWidth;
          cropped.height = cropHeight;
          cropped.getContext("2d")!.drawImage(canvas, 0, 0, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
          resolve([cropped.toDataURL("image/jpeg", 0.92), fullPdfBase64]);
        } catch (e) {
          reject(e);
        }
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const handleRemoveFile = () => {
    if (progressRef.current) clearInterval(progressRef.current);
    setSelectedFile(null);
    setSelectedFileName(null);
    setUploadComplete(false);
    setIsLoading(false);
    setLoadingProgress(0);
  };

  const closeModal = () => {
    setIsSuccessModalOpen(false);
    if (progressRef.current) clearInterval(progressRef.current);
    setSelectedFile(null);
    setSelectedFileName("");
    setLoadingProgress(0);
    setUploadComplete(false);
  };

    useEffect(() => {
      if(sessionStorage.getItem('document_type') &&
      sessionStorage.getItem('document_type') === 'passport'){
        window.location.href = "/instructions-document";
      }
    }, []);

  return (
    <>
      <div className="welcome-card">
        <h1 className="bepass-title-doc">{t("document_upload_choose.title")}</h1>

        <p className="bepass-text-default">
          <Trans
            i18nKey="document_upload_choose.quote"
            components={{
              bold1: <strong />,
              bold2: <strong />,
              bold3: <strong />,
              bold4: <strong />,
            }}
          />
        </p>

        <ul className="document-type-select">
          <li onClick={() => documentHandlerUrl()}>
            <Box className="type-select-description">
              <div className="icon-and-title">
                <i>
                  <CameraAltOutlinedIcon />
                </i>
                <h2 className="bepass-title-doc-title">
                  {t("document_upload_choose.capture_document")}
                </h2>
              </div>
              <p className="bepass-text-label">
                <Trans
                  i18nKey="document_upload_choose.capture_document_text"
                  components={{ bold1: <strong />, bold2: <strong /> }}
                />
              </p>
            </Box>
          </li>

          <li>
            <Box
              className="type-select-description uploading"
              onClick={(e) => {
                e.stopPropagation();
                document.getElementById("file-sender")?.click();
              }}
            >
              {isLoading && selectedFile ? (
                <div className="document-upload-box uploading">
                  <div className="document-upload-header">
                    <div className="document-upload-info with-preview">
                      {previewUrl && previewUrl.startsWith("data:image") && (
                        <img
                          src={previewUrl}
                          alt="Preview"
                          className="document-upload-thumbnail"
                        />
                      )}
                      <div className="document-upload-text-info">
                        <p className="file-name">{selectedFileName}</p>
                        <p className="upload-meta-doc">
                          {loadingProgress}% •{" "}
                          {Math.max(1, Math.ceil((100 - loadingProgress) / 10))}{" "}
                          {t("step.second")}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="document-upload-progress-wrapper">
                    <div className="progress-row">
                      <div className="document-progress-bar">
                        <div
                          className="document-progress-bar-fill"
                          style={{ width: `${loadingProgress}%` }}
                        />
                      </div>
                      <button
                        className="document-delete-file-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveFile();
                        }}
                      >
                        <CloseIcon />
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {!uploadComplete ? (
                    <>
                      <div className="icon-and-title">
                        <i>
                          <WaFiUploadCloud />
                        </i>
                        <h2 className="bepass-title-doc-title">
                          {t("document_upload_choose.cnh_digital")}
                        </h2>
                      </div>
                      <input
                        id="file-sender"
                        type="file"
                        accept=".pdf,application/pdf"
                        capture={false}
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <p className="bepass-text-label">
                        <Trans
                          i18nKey="document_upload_choose.cnh_digital_text"
                          components={{ bold1: <strong />, bold2: <strong /> }}
                        />
                      </p>
                      {error && <p style={{ color: "red" }}>{error}</p>}
                    </>
                  ) : (
                    <div
                      className={`document-upload-box ${
                        uploadComplete ? "complete" : "uploading"
                      }`}
                    >
                      <div className="document-upload-header">
                        <div
                          className={`document-upload-info ${
                            previewUrl ? "with-preview" : ""
                          }`}
                        >
                          {previewUrl && (
                            <img
                              src={previewUrl}
                              alt="preview"
                              className="document-upload-thumbnail"
                            />
                          )}
                          <div className="document-upload-text-info">
                            <p className="file-name">{selectedFileName}</p>
                            <p
                              className={
                                uploadComplete
                                  ? "success-text-doc"
                                  : "upload-meta-doc"
                              }
                            >
                              {uploadComplete
                                ? t("step.upload")
                                : `${loadingProgress}% • ${Math.max(
                                    1,
                                    Math.ceil((100 - loadingProgress) / 10)
                                  )} ${t("step.second")}`}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="document-upload-progress-wrapper">
                        <div className="progress-row">
                          <div className="document-progress-bar">
                            <div
                              className="document-progress-bar-fill"
                              style={{ width: `${loadingProgress}%` }}
                            />
                          </div>
                          <button
                            className="document-delete-file-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveFile();
                            }}
                          >
                            {uploadComplete ? <WaFiTrash2 /> : <CloseIcon />}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </Box>
          </li>
        </ul>

        {uploadComplete && (
          <div className="document-upload-summary">
            <button
              className="btn_send_document"
              onClick={handleSend}
              disabled={isSending}
            >
              <p>{isSending ? t("step.sending") : t("step.send")}</p>
            </button>
          </div>
        )}

        <ModalInfo
          isOpen={isSuccessModalOpen}
          onClose={closeModal}
          overlayClassName="ModalInfoOverlay"
        >
          <div className="modal-document-handler">
            <h1 className="modal-title">{t("modal_document_handler.title")}</h1>
            <p className="modal-quote primary">{t("modal_document_handler.quote")}</p>
            <p className="modal-quote">{t("modal_document_handler.quote_2")}</p>
            <button
              className="btn_send_document modal-action-button"
              onClick={closeModal}
            >
              <span>{t("modal_document_handler.call_to_action")}</span>
            </button>
          </div>
        </ModalInfo>
      </div>
    </>
  );
};

export default DocumentHandler;
